import React, {useEffect} from 'react';
import {Download} from "@mui/icons-material";
import Button from "@mui/material/Button";
import {useLazyGetEventPilotRegistrationsQuery} from "../../slices/apiSlice";
import {sortEntriesPerSgpRules} from "../../pages/Event/PilotRegistrationList";
import {countryArray, isViableRegistrationStatus} from "../../util/standards-util";
import moment from "moment-timezone";

const DownloadEntryListWidget = ({event}) => {
    const eventCountry = event.country
    const eventEntryNo = 20

    const [hasDownloaded, setHasDownloaded] = React.useState(false)

    const [getRegistrations, getRegistrationsResult] =
        useLazyGetEventPilotRegistrationsQuery()

    const handleDownload = () => {
        getRegistrations({eventId:event.id})
    }

    const fu = (v)=>{
        return v!== undefined ? v : ''
    }

    useEffect(() => {
        if (getRegistrationsResult.isSuccess && !hasDownloaded) {
            const data = getRegistrationsResult.data
            const entries = sortEntriesPerSgpRules(
                data.registrations.map((reg)=>{
                    return {
                        registration:reg,
                        details:data.details.find( d => d.i === reg.i),
                        pilot:data.pilots.find(p => p.id === reg.p),
                    }
                }),
                event
            )

            let txt = `"#",`+
                `"Pilot",`+
                `"Nationality",`+
                `"Comp ID",`+
                `"Sailplane",`+
                `"Sailplane Registration",`+
                `"Ranking",`+
                `"Register date",`+
                `"Email",`+
                `"IGC Ranking List ID",`+
                `"Primary logger serial",`+
                `"Secondary logger serial",`+
                `"Flarm ID",`+
                `"Mobile number",`+
                `"Street address",`+
                `"Street address 2",`+
                `"City",`+
                `"Postal code",`+
                `"State/Province/Region",`+
                `"Country address",`+
                `"Comp mobile number",`+
                `"Crew name",`+
                `"Crew mobile number",`+
                `"Crew secondary mobile number",`+
                `Crew email`+
                `\r\n`

            for (let i=0; i<entries.length ; i++) {
                const reg=entries[i].registration
                const details=entries[i].details
                const pilot=entries[i].pilot

                if (!isViableRegistrationStatus(reg.u)) continue

                txt+=`${i < eventEntryNo  ? i + 1 : '-'},`+
                        `"${pilot.firstname} ${pilot.lastname}",`+
                        `"${fu(countryArray.find( c => c.key===pilot.nationality).label)}",`+
                        `"${fu(details.compId)}",`+
                        `"${fu(details.gliderDescription)}",`+
                        `"${fu(details.sailplaneRegistration)}",`+
                        `"${fu(reg.m)}",`+
                        `"${fu(moment(reg.r).format("D MMM YYYY"))}",`+
                        `"${fu(details.email)}",`+
                        `"${fu(details.igcRankingId)}",`+
                        `"${fu(details.primaryLoggerSerial)}",`+
                        `"${fu(details.secondaryLoggerSerial)}",`+
                        `"${fu(details.flarmId)}",`+
                        `"${fu(details.phone)}",`+
                        `"${fu(details.address1)}",`+
                        `"${fu(details.address2)}",`+
                        `"${fu(details.city)}",`+
                        `"${fu(details.zipcode)}",`+
                        `"${fu(details.region)}",`+
                        `"${fu(countryArray.find( c => c.key===details.country)?.label)}",`+
                        `"${fu(details.competitionPhone)}",`+
                        `"${fu(details.crewName)}",`+
                        `"${fu(details.crewPhone)}",`+
                        `"${fu(details.crewCompetitionPhone)}",`+
                        `"${fu(details.crewEmail)}"`+
                        `\r\n`
            }

            setHasDownloaded(true)

            const blob = new Blob([txt], { type: "text/csv" })
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.download = `${event.fullEditionTitle} - entry list.csv`
            link.href = url;
            link.click();
        }

    }, [getRegistrationsResult]);

    return (
        <>
            <Button
                onClick={handleDownload}
                size = 'small'
                endIcon={<Download/>}
            >
                Download entry list
            </Button>
        </>
    )
}

export default DownloadEntryListWidget;